import React from 'react'
import { Link } from 'gatsby'
import Navigation from './navigation'
import SceneSwitch from './sceneSwitch'

const Header = () => (
  <header className="masthead">
    <div className="container">
      <div className="header-title">
        <Link to="/">
          <span className="title">Zane <span className="title-surname">Staggs</span></span>
        </Link>
      </div>
      <div className="masthead-right">
        <Navigation />
        <SceneSwitch />
      </div>
    </div>
  </header>
)

export default Header
